module.exports = "https://trybtryb-legacy.web.app/img/customization.2064d243.svg";